// import * as React from 'react';
import Error from './error';

export default function Forbidden() {
	return (
		<Error
			errorCode="403"
			errorName="FORBIDDEN"
			description="You don't have the necessary permissions to view this resource"
		/>
	);
}